<template>
  <v-container fluid>
    <page-header />

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :itemTotal="tableTotal"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      @options-update="getList()"
      disableToolbar
    >
      <template v-slot:[`item.company_type`]="{ item }">{{ item.company_type | formatCompanyType }}</template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormSelect from '@/components/form/FormSelect.vue'
import FormDatePicker from '@/components/form/FormDatePicker.vue'
export default {
  name: 'AppliedServiceList',
  components: {
    Datatable,
    FormSelect,
    FormDatePicker,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
    tableHeaders: [
      { value: 'create_date', text: vm.$t('submitDate'), width: 130 },
      { value: 'contact_name', text: vm.$t('userName'), width: 250 },
      { value: 'phone', text: vm.$t('userPhone'), width: 250 },
      { value: 'company_type', text: vm.$t('companyType'), width: 110 },
      { value: 'company_name_en', text: vm.$t('companyNameEn'), width: 250 },
      { value: 'company_name_zh', text: vm.$t('companyNameZh'), width: 250 },
      { value: 'br_number', text: vm.$t('brNumber'), width: 150 },
      { value: 'service', text: vm.$t('service'), width: 300 },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        let payload = {
          filter_page: this.tableFilter.page - 1,
          filter_limit: this.tableFilter.limit,
        }

        const { total, data } = await this.$Fetcher.GetAppliedServices(payload)
        this.tableTotal = total
        this.tableData = data.map(item => {
          const services = []
          if (item.plan_data_list) {
            item.plan_data_list.forEach(el => {
              services.push(this.$Formatter.getServiceName(el.name_zh, this.$t(`planTypeOption.${el.type}`)))
            })
          }

          let contactPhone = ''
          if (item.company_data) {
            contactPhone = item.company_data.contact_tel
              ? `(${item.company_data.contact_zone}) ${item.company_data.contact_tel}`
              : ''
          } else if (item.contact_name) {
            contactPhone = item.contact_phone ? `(${item.contact_zone}) ${item.contact_phone}` : ''
          }

          return {
            id: item.id,
            create_date: item.create_date,
            contact_name: item.company_data ? item.company_data.contact_en : item.contact_name,
            phone: contactPhone,
            company_type: item.company_data ? item.company_data.type : '',
            company_name_en: item.company_data ? item.company_data.name_en : item.company_name_en,
            company_name_zh: item.company_data ? item.company_data.name_zh : item.company_name_zh,
            br_number: item.company_data ? item.company_data.br_number : item.company_number,
            service: services,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
